const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      color: theme.colors[0],
    },
    hero: {
      color: theme.colors[1],
    },
    pageContent: {
      '& > *:not(:first-child)': {
        paddingTop: 90,
        paddingBottom: 90,
      },
      '& > *:last-child': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    pageContent: {
      '& > *:not(:first-child)': {
        paddingTop: 45,
        paddingBottom: 45,
      },
      '& > *:last-child': {
        paddingBottom: 0,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
